<section class="architects-page container">
  <h1 class="architects-page__header">
    {{ 'header.forArchitectsDesigners' | translate }}
  </h1>
  <div class="architects-page__content">
    <pwj-solutions-people-browse
      filterType="ARCHITECT"
      noContentMessageKey="industries.noIndustries" />
  </div>
</section>
